var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyClient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0654 8.27431V35.8739C10.0654 55.6822 22.4132 73.3905 41.0001 80.2383C59.587 73.3905 71.9348 55.6822 71.9348 35.8739V8.27431C51.3118 -0.409197 30.6884 -0.409197 10.0654 8.27431Z",
    stroke: "#333333",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3966 53.7536V52.5598C52.3966 46.2653 47.294 41.1627 40.9996 41.1627C34.7051 41.1627 29.6025 46.2653 29.6025 52.5598V53.7536",
    stroke: "#AAAAAA",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9999 41.1629C44.5967 41.1629 47.5125 38.2471 47.5125 34.6503C47.5125 31.0535 44.5967 28.1377 40.9999 28.1377C37.4031 28.1377 34.4873 31.0535 34.4873 34.6503C34.4873 38.2471 37.4031 41.1629 40.9999 41.1629Z",
    stroke: "#AAAAAA",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9997 57.4444C51.7901 57.4444 60.5375 48.697 60.5375 37.9066C60.5375 27.1162 51.7901 18.3688 40.9997 18.3688C30.2093 18.3688 21.4619 27.1162 21.4619 37.9066C21.4619 48.697 30.2093 57.4444 40.9997 57.4444Z",
    stroke: "#333333",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyClient);
export default __webpack_public_path__ + "static/media/empty_client.ad4d4a421b2767199a081e7a238ac084.svg";
export { ForwardRef as ReactComponent };